<script lang="ts" setup>
  import { GameInteractionContent } from '~/model/GameInteraction/GameInteraction'
  import InteractionCompleteBox from '~/components/InteractionCompleteBox/InteractionCompleteBox.vue'
  import { resolveComponent } from '#imports'
  import { ContentBlockTypeId } from '~/model/ContentBlockData/ContentBlockData'
  import { ContentBlockFacet } from '~/components/ContentBlock/ContentBlockFacet'
  import { VisualThemeId } from '~/model/VisualTheme/VisualTheme'

  interface Props {
    content: GameInteractionContent
  }

  const ContentBlockAudio = resolveComponent('ContentBlockAudio') as string
  const ContentBlockFile = resolveComponent('ContentBlockFile') as string
  const ContentBlockImage = resolveComponent('ContentBlockImage') as string
  const ContentBlockInfoBox = resolveComponent('ContentBlockInfoBox') as string
  const ContentBlockIntroduction = resolveComponent('ContentBlockIntroduction') as string
  const ContentBlockLearnSnack = resolveComponent('ContentBlockLearnSnack') as string
  const ContentBlockQuote = resolveComponent('ContentBlockQuote') as string
  const ContentBlockRichText = resolveComponent('ContentBlockRichText') as string
  const ContentBlockTable = resolveComponent('ContentBlockTable') as string
  const ContentBlockTask = resolveComponent('ContentBlockTask') as string

  const props = defineProps<Props>()

  const getComponent = (type: ContentBlockTypeId) => {
    switch (type) {
      case ContentBlockTypeId.Audio:
        return ContentBlockAudio
      case ContentBlockTypeId.File:
        return ContentBlockFile
      case ContentBlockTypeId.Image:
        return ContentBlockImage
      case ContentBlockTypeId.InfoBox:
        return ContentBlockInfoBox
      case ContentBlockTypeId.Introduction:
        return ContentBlockIntroduction
      case ContentBlockTypeId.LearnSnack:
        return ContentBlockLearnSnack
      case ContentBlockTypeId.Quote:
        return ContentBlockQuote
      case ContentBlockTypeId.RichText:
        return ContentBlockRichText
      case ContentBlockTypeId.Table:
        return ContentBlockTable
      case ContentBlockTypeId.Task:
        return ContentBlockTask
    }
  }
</script>

<template>
  <div class="c-interaction-body">
    <div class="s-container s-container--primary">
      <div class="s-container__container">
        <div class="s-grid s-grid--primary c-interaction-body__blocks">
          <component
            :is="getComponent(type)"
            v-for="({ facets, type, ...block }, blockIdx) in content.contentList"
            :key="blockIdx"
            :facets="[VisualThemeId.Positive, ContentBlockFacet.InInteraction, ...(facets ?? [])]"
            :type="type"
            v-bind="block"
          />
          <InteractionCompleteBox :interaction-id="content.id" :category="content.category" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .c-interaction-body {
    z-index: 0;
    position: relative;
    padding: 60px 0 100px;
  }

  .c-interaction-body__blocks {
    row-gap: 44px;
  }
</style>
